<template>
  <div class="max-w-2xl mx-auto py-8 px-4">
    <h2 class="text-2xl font-bold mb-2">Prise de connaissance</h2>

    <p class="text-gray-600 mb-6">Cochez chaque document pour confirmer que vous en avez bien pris connaissance.</p>

    <div class="space-y-4">
      <label class="flex items-start gap-3 p-4 border border-gray-200 rounded-lg cursor-pointer hover:bg-gray-50">
        <input v-model="checks.formulaChangeLetter" type="checkbox" class="mt-1 h-4 w-4 text-primary rounded-sm" />
        <div>
          <p class="font-bold">Courrier d'information de changement de formule</p>
          <p class="text-sm text-gray-500">
            Synthèse de la résiliation MMA et de la nouvelle couverture Acheel &middot;
            <a
              v-if="plan.formulaChangeLetter"
              :href="plan.formulaChangeLetter"
              target="_blank"
              rel="noopener noreferrer"
              class="text-primary hover:underline"
              @click.stop
            >
              Ouvrir le PDF
            </a>
          </p>
        </div>
      </label>

      <label class="flex items-start gap-3 p-4 border border-gray-200 rounded-lg cursor-pointer hover:bg-gray-50">
        <input v-model="checks.informationNotice" type="checkbox" class="mt-1 h-4 w-4 text-primary rounded-sm" />
        <div>
          <p class="font-bold">Notice d'information Acheel (ACHL_EST_BIKE)</p>
          <p class="text-sm text-gray-500">
            Conditions générales complètes du nouveau contrat &middot;
            <a
              v-if="plan.informationNotice"
              :href="plan.informationNotice"
              target="_blank"
              rel="noopener noreferrer"
              class="text-primary hover:underline"
              @click.stop
            >
              Ouvrir le PDF
            </a>
          </p>
        </div>
      </label>

      <label class="flex items-start gap-3 p-4 border border-gray-200 rounded-lg cursor-pointer hover:bg-gray-50">
        <input v-model="checks.ipid" type="checkbox" class="mt-1 h-4 w-4 text-primary rounded-sm" />
        <div>
          <p class="font-bold">Fiche d'information produit (IPID)</p>
          <p class="text-sm text-gray-500">
            Résumé réglementaire des garanties, franchises et exclusions &middot;
            <a
              v-if="plan.ipidFile"
              :href="plan.ipidFile"
              target="_blank"
              rel="noopener noreferrer"
              class="text-primary hover:underline"
              @click.stop
            >
              Ouvrir le PDF
            </a>
          </p>
        </div>
      </label>

      <label class="flex items-start gap-3 p-4 border border-gray-200 rounded-lg cursor-pointer hover:bg-gray-50">
        <input v-model="checks.membershipAgreement" type="checkbox" class="mt-1 h-4 w-4 text-primary rounded-sm" />
        <div>
          <p class="font-bold">Bulletin d'adhésion modificatif</p>
          <p class="text-sm text-gray-500">
            Détail personnalisé de votre adhésion &middot;
            <a
              v-if="membershipAgreementUrl"
              :href="membershipAgreementUrl"
              target="_blank"
              rel="noopener noreferrer"
              class="text-primary hover:underline"
              @click.stop
            >
              Ouvrir le PDF
            </a>
          </p>
        </div>
      </label>
    </div>

    <div class="mt-8 flex justify-between">
      <SecondaryButton @click="$emit('previous')">PRÉCÉDENT</SecondaryButton>
      <PrimaryButton :disabled="!allChecked" @click="$emit('next')">CHOISIR &rarr;</PrimaryButton>
    </div>
  </div>
</template>

<script>
import { PrimaryButton, SecondaryButton } from "@estaly/ui";
import { mapActions, mapState } from "vuex";

export default {
  components: { PrimaryButton, SecondaryButton },

  props: {
    plan: {
      type: Object,
      required: true,
    },
  },

  emits: ["next", "previous"],

  data() {
    return {
      checks: {
        formulaChangeLetter: false,
        informationNotice: false,
        ipid: false,
        membershipAgreement: false,
      },
    };
  },

  computed: {
    ...mapState("planSales", ["membershipAgreementUrl"]),
    allChecked() {
      return Object.values(this.checks).every(Boolean);
    },
  },

  async created() {
    await this.fetchMembershipAgreement(this.plan.friendlyId);
  },

  methods: {
    ...mapActions("planSales", ["fetchMembershipAgreement"]),
  },
};
</script>
